import actionTypes from '../../../../../actions/Ui/Views/Accounts/Pnl/actionTypes';

const initialState = {
  isLoadingTable: false,
  isLoadingChart: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING_TABLE:
      return {
        ...state,
        isLoadingTable: true,
      };
    case actionTypes.LOADED_TABLE:
      return {
        ...state,
        isLoadingTable: false,
      };
    case actionTypes.LOADING_CHART:
      return {
        ...state,
        isLoadingChart: true,
      };
    case actionTypes.LOADED_CHART:
      return {
        ...state,
        isLoadingChart: false,
      };
    default:
      return state;
  }
}
